import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-535047fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col pl-[16px] pt-[16px] ibf-h2" }
const _hoisted_2 = { class: "mb-[16px] mx-[16px] mt-[8px]" }
const _hoisted_3 = { class: "text-Text/text_low text-[12px]" }
const _hoisted_4 = { class: "flex mt-[16px] justify-between" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-Text/text_medium text-[13px]" }, "Status:", -1))
const _hoisted_7 = { class: "flex items-center flex-nowrap ml-[8px]" }
const _hoisted_8 = {
  key: 0,
  class: "manage-groups-block"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-full mt-[8px]" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "flex mt-[8px] justify-between"
}
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-Text/text_medium text-[13px]" }, "Security groups assigned:", -1))
const _hoisted_13 = { class: "flex items-center flex-nowrap ml-[8px]" }
const _hoisted_14 = { class: "text-Text/text_high text-[12px]" }
const _hoisted_15 = {
  style: {"width":"336px"},
  class: "rounded-sm"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "mt-[8px]" }

import { computed, inject, onMounted, onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Maybe } from 'graphql/jsutils/Maybe';
import { IncrediButton, IncrediLegend, IncrediNote, IncrediTooltip, useIncrediDialog } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import COLORS from '@/design-system/colors.json';
import { Authentication_OrganizationGroupsErrorCode, External_Authentication_Type, Settings_ExternalAuth, useSettings_ExternalAuthsQuery, useUserQuery } from '@/graphql/codegen/generated/graphql';
import ConnectActiveDirectoryDialog from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectoryDialog.vue';
import ManageSecurityGroupsDialog from '@/components/common/dialogs/settingsActiveDirectoryDialog/manageSecurityGroupsDialog/manageSecurityGroupsDialog.vue';
import { useManageSecurityGroupsHelpers } from '@/components/common/dialogs/settingsActiveDirectoryDialog/manageSecurityGroupsDialog/manageSecurityGroupsDialog.helpers';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import { ActiveDirectoryStatus } from '@/views/settings/const';
import { IKActiveDirectoryManageGroups } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectory.injection.keys';


export default /*#__PURE__*/_defineComponent({
  __name: 'settingsActiveDirectory',
  props: {
    enabled: { type: Boolean },
    auth: null
  },
  setup(__props: any) {

const props = __props as { enabled: boolean; auth: Maybe<Settings_ExternalAuth> }

useManageSecurityGroupsHelpers();
const { t } = useI18n();
const userRolePermissions = useUserRolePermissions();
const manageSecurityGroupsHelpers = inject(IKActiveDirectoryManageGroups);

const showDisableManagerGroupsTooltip = ref(false);
const GQL_userInfo = useUserQuery();

const GQL_get_Active_Directory = useSettings_ExternalAuthsQuery();
const ldapAuthData = computed(() => GQL_get_Active_Directory?.result?.value?.settings_externalAuths?.ldapAuth);

const colorMapByStatus = {
  [ActiveDirectoryStatus.azureADEnabled]: COLORS['System/app_primary'],
  [ActiveDirectoryStatus.disabled]: `${COLORS['System/app_disabled']}40`,
  [ActiveDirectoryStatus.adEnabled]: COLORS['System/app_primary'],
};

const mappingsCount = computed(() => manageSecurityGroupsHelpers?.groupRoleMapping.value?.length || 0);

const errorCode = computed(() => manageSecurityGroupsHelpers?.GQL_Groups?.result?.value?.authentication_get_organization_groups?.errorCode || '');

const isGroupsManageDialogDisabled = computed(() => props.auth?.authenticationType === External_Authentication_Type.Ldap && mappingsCount.value > 0 && !ldapAuthData?.value?.groupSearchBase);

const isUnauthorized = computed(() => !GQL_userInfo.result.value?.user?.local && errorCode.value === Authentication_OrganizationGroupsErrorCode.Unauthorized);

const isLdapNotConnected = computed(() => errorCode.value === Authentication_OrganizationGroupsErrorCode.ActiveDirectoryNotConnected);

const dialogText = computed(() => {
  if (isGroupsManageDialogDisabled.value) {
    return t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.disabledDialogTooltip');
  }
  if (isUnauthorized.value) {
    return t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.unauthorizedTooltip');
  }
  if (isLdapNotConnected.value) {
    return t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.ldapNotConnectedTooltip');
  }
  return '';
});

const isDialogDisabled = computed(() => isGroupsManageDialogDisabled.value || isUnauthorized.value || isLdapNotConnected.value);

const activeDirectoryStatus = computed(() => {
  if (props?.enabled) {
    if (props.auth?.authenticationType === External_Authentication_Type.AzureAd) {
      return ActiveDirectoryStatus.azureADEnabled;
    }
    if (props.auth?.authenticationType === External_Authentication_Type.Ldap) {
      return ActiveDirectoryStatus.adEnabled;
    }
  }
  return ActiveDirectoryStatus.disabled;
});

const dialog = useIncrediDialog();

const openADDialog = () => {
  dialog?.open('connectActiveDirectoryDialog', ConnectActiveDirectoryDialog, {});
};

const openManageGroupsDialog = () => {
  dialog?.open('manageSecurityGroupsDialog', ManageSecurityGroupsDialog, {});
};

onUnmounted(() => {
  dialog?.close('connectActiveDirectoryDialog');
  dialog?.close('manageSecurityGroupsDialog');
});

onMounted(async () => {
  const authMode = sessionStorage.getItem('authMode');
  if (authMode === 'true') {
    openManageGroupsDialog();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createBlock(IbxScopedCss, { class: "w-full directory--container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('settings.general.userAuth.title')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('settings.general.userAuth.text')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(IncrediLegend), {
                size: 8,
                class: "dot",
                color: colorMapByStatus[_unref(activeDirectoryStatus)]
              }, null, 8, ["color"]),
              _createElementVNode("div", {
                class: _normalizeClass([_unref(activeDirectoryStatus) === _unref(ActiveDirectoryStatus).disabled ? 'text-Text/text_low' : 'text-Text/text_high', "ml-[8px] text-[12px]"])
              }, _toDisplayString(_unref(activeDirectoryStatus)), 3)
            ])
          ]),
          _createVNode(_unref(IncrediButton), {
            design: __props.enabled ? 'secondary-green' : 'primary-green',
            size: "small",
            disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
            onClick: _withModifiers(openADDialog, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass([__props.enabled ? 'px-[24px]' : '', "flex items-center flex-nowrap"])
              }, _toDisplayString(__props.enabled ? _ctx.$t('settings.dialogs.connectActiveDirectory.footer.edit') : _ctx.$t('settings.dialogs.connectActiveDirectory.footer.activate')), 3)
            ]),
            _: 1
          }, 8, ["design", "disabled", "onClick"])
        ]),
        (__props.enabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              true
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(mappingsCount)), 1)
                      ])
                    ]),
                    _createVNode(_unref(IncrediTooltip), {
                      direction: "middle-left",
                      "model-value": _unref(isDialogDisabled) && showDisableManagerGroupsTooltip.value,
                      delay: 200,
                      "offset-x": 4,
                      hover: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = (value)=> showDisableManagerGroupsTooltip.value = value)
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(dialogText)), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(IncrediButton), {
                          design: _unref(mappingsCount) > 0 ? 'secondary-green' : 'primary-green',
                          size: "small",
                          disabled: _unref(isDialogDisabled) || !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                          onClick: _withModifiers(openManageGroupsDialog, ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass([_unref(mappingsCount) > 0 ? 'px-[24px]' : 'px-[16px]', "flex items-center flex-nowrap"])
                            }, _toDisplayString(_unref(mappingsCount) > 0 ? _ctx.$t('settings.dialogs.connectActiveDirectory.footer.edit') : _ctx.$t('settings.dialogs.connectActiveDirectory.footer.define')), 3)
                          ]),
                          _: 1
                        }, 8, ["design", "disabled", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_q_skeleton, {
                        class: "bg-System/app_grey_95",
                        height: "32px",
                        type: "QRange"
                      })
                    ])
                  ])),
              (_unref(mappingsCount) === 0)
                ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                    key: 2,
                    class: "mt-[4px]",
                    type: "Warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.noGroupWaringNote')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})